import { Button, Form, Input, message } from 'antd'
import type { FormProps } from 'antd'
import React, { useCallback, useState } from 'react'

import { patchAgent, postAgent } from '~/services/agent'
import { IAgent } from '~/types/agent'

import { ModalFormContainer } from './style'

const Index: React.FC<{
  data: Partial<IAgent>
  refreshTable: () => void
}> = (props) => {
  const { data, refreshTable } = props

  const [loading, setLoading] = useState(false)
  const onFinish = useCallback<
    Required<FormProps<Partial<IAgent>>>['onFinish']
  >(
    (value) => {
      setLoading(true)
      if (!data.id) {
        postAgent(value)
          .then(() => {
            message.success('操作成功')
            refreshTable()
          })
          .catch((err) => {
            message.error(
              err.response.data || err?.message || '操作失败，请稍后再试',
            )
          })
          .finally(() => {
            setLoading(false)
          })
      } else {
        patchAgent(data.id, value)
          .then(() => {
            message.success('操作成功')
            refreshTable()
          })
          .catch((err) => {
            message.error(
              err.response.data || err?.message || '操作失败，请稍后再试',
            )
          })
          .finally(() => {
            setLoading(false)
          })
      }
    },
    [data.id, refreshTable],
  )

  return (
    <ModalFormContainer>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        autoComplete="off"
        initialValues={data}
        onFinish={onFinish}
      >
        <Form.Item
          label="用户名"
          name="name"
          rules={[{ required: true, message: '请输入用户名' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="手机号码"
          name="phone"
          rules={[{ required: true, message: '请输入用户名' }]}
        >
          <Input style={{ width: 150 }} />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button loading={loading} type="primary" htmlType="submit">
            提交
          </Button>
        </Form.Item>
      </Form>
    </ModalFormContainer>
  )
}

export default Index
